import styled from 'styled-components';

import { FlexRow } from 'styles/layouts';

export const SubmitArea = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column-reverse;
`;

export const DialogTitle = styled(FlexRow)`
  border-bottom: 1px solid var(--color-border);
`;
